(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multi-column"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadImage = (image) => {
      if (!image.dataset.deferredSrc) return;
      image.srcset = image.dataset.deferredSrcset;
      image.src = image.dataset.deferredSrc;
      delete image.dataset.deferredSrcset;
      delete image.dataset.deferredSrc;
    };

    const observeImages = (root) => {
      const images = root.querySelectorAll('.shirley-deferred-image[data-deferred-src]');

      if (!('IntersectionObserver' in window)) {
        images.forEach(loadImage);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          loadImage(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '200px 0px' });

      images.forEach((image) => observer.observe(image));
    };

    const start = (root = document) => {
      const hero = document.querySelector('main img[fetchpriority="high"]');

      if (hero && !hero.complete) {
        hero.addEventListener('load', () => observeImages(root), { once: true });
      } else {
        observeImages(root);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => start(), { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => start(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-brand-directory"] && !Shopify.designMode) return;
  try {
    
function initShirleyBrands(root){if(root.dataset.ready)return;root.dataset.ready='true';const search=root.querySelector('input[type="search"]');const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');const status=root.querySelector('[data-results]');function filter(){const q=normalize(search.value);let count=0;root.querySelectorAll('[data-directory]').forEach(dir=>{let visible=0;dir.querySelectorAll('[data-letter]').forEach(group=>{let matches=0;group.querySelectorAll('.ss-brands__names p').forEach(p=>{p.hidden=!normalize(p.textContent).includes(q);if(!p.hidden)matches++});group.hidden=matches===0;const link=dir.querySelector('[href="#'+group.id+'"]');if(link)link.hidden=group.hidden;visible+=matches});dir.querySelector('.ss-brands__empty').hidden=visible>0;dir.querySelector('.ss-brands__alphabet').hidden=visible===0;count+=visible});status.textContent=count+' '+status.dataset.count}search.addEventListener('input',filter);root.querySelector('[data-clear]').addEventListener('click',()=>{search.value='';filter();search.focus()});root.querySelector('.ss-brands__search').hidden=false;filter()}
document.querySelectorAll('.ss-brands').forEach(initShirleyBrands);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.ss-brands').forEach(initShirleyBrands));

  } catch(e) { console.error(e); }
})();
})();
